// extracted by mini-css-extract-plugin
module.exports = {"AlertBubble":"AlertBubble_AlertBubble__TuG8x"};